/* eslint-disable */

import { Tag } from 'antd';

export function orderStatus(order, viewmode) {
  if (!order) return null;
  if (order.order_status === 'IV_Req') {
    if (order.api_paymentstatus === 'Success') {
      return <Tag color='success'>รอผู้ขายตอบรับคำสั่งซื้อ</Tag>;
    } else if (order.api_paymentstatus === 'Fail') {
      return <Tag color='error'>ชำระเงินไม่สำเร็จ</Tag>;
    } else if (order.api_paymentstatus === 'Cancel') {
      return <Tag color='warning'>ลูกค้ายกเลิกการชำระเงิน</Tag>;
    } else if (order.api_paymentstatus === 'Error') {
      return <Tag color='error'>เกิดข้อผิดพลาด</Tag>;
    } else if (order.api_paymentstatus === 'Transaction Pending') {
      return <Tag color='processing'>รอการชำระค่าสินค้า</Tag>;
    } else if (order.api_paymentstatus === 'Void Success') {
      return <Tag color='success'>Void สำเร็จ</Tag>;
    } else if (order.api_paymentstatus === 'Refund Success') {
      return <Tag color='success'>Refund สำเร็จ</Tag>;
    } else if (order.api_paymentstatus === 'Request to Refund') {
      return <Tag color='processing'>กำลังขอ Refund</Tag>;
    } else if (order.api_paymentstatus === 'Settlement Success') {
      return <Tag color='success'>โอนเงินให้ร้านค้าสำเร็จ</Tag>;
    } else if (order.api_paymentstatus === 'Void Fail') {
      return <Tag color='error'>Void ไม่สำเร็จ</Tag>;
    } else if (order.api_paymentstatus === 'Refund Fail') {
      return <Tag color='error'>Refund ไม่สำเร็จ</Tag>;
    } else {
      return <Tag color='error'>ไม่ทราบสถานะการชำระเงิน</Tag>;
    }
  } else if (order.order_status === 'IV_Cancel') {
    return <Tag color='warning'>ผู้ซื้อยกเลิกคำสั่งซื้อ</Tag>;
  } else if (order.order_status === 'IV_EXP') {
    return <Tag color='error'>หมดอายุชำระเงิน</Tag>;
  } else if (order.order_status === 'IV_C_Cancel') {
    return <Tag color='warning'>ผู้ซื้อยกเลิกคำสั่งซื้อ</Tag>;
  } else if (order.order_status === 'IV_V_Cancel') {
    return <Tag color='warning'>ผู้ขายยกเลิกคำสั่งซื้อ</Tag>;
  } else if (order.order_status === 'IV_Refunded') {
    return <Tag color='processing'>คืนเงินที่ผู้ซื้อยกเลิกสำเร็จ</Tag>;
  } else if (order.order_status === 'PC_Prepare') {
    return <Tag color='success'>ผู้ขายตอบรับคำสั่งซื้อแล้ว</Tag>;
  } else if (order.order_status === 'PC_C_Cancel_Req') {
    return <Tag color='warning'>ผู้ซื้อขอยกเลิกคำสั่งซื้อ</Tag>;
  } else if (order.order_status === 'PC_C_Cancel_AC') {
    return <Tag color='processing'>ผู้ขายตอบรับการยกเลิกคำสั่งซื้อ</Tag>;
  } else if (order.order_status === 'PC_C_Cancel_AT') {
    return <Tag color='processing'>ยกเลิกคำสั่งซื้ออัตโนมัติ</Tag>;
  } else if (order.order_status === 'PC_V_Cancel') {
    return <Tag color='warning'>ผู้ขายยกเลิกคำสั่งซื้อ</Tag>;
  } else if (order.order_status === 'PC_Book') {
    return <Tag color='processing'>ผู้ขายกำลังเตรียมพัสดุ</Tag>;
  } else if (order.order_status === 'PC_C_Book_Cancel_Req') {
    return <Tag color='warning'>ผู้ซื้อขอยกเลิกคำสั่งซื้อ</Tag>;
  } else if (order.order_status === 'PC_C_Book_Cancel_AC') {
    return <Tag color='processing'>ผู้ขายตอบรับการยกเลิกคำสั่งซื้อ</Tag>;
  } else if (order.order_status === 'PC_BookConfirm') {
    if (order.shipping_status === 'pending') {
      return <Tag color='processing'>จองระบบขนส่งแล้ว</Tag>;
    } else if (order.shipping_status === 'booking') {
      return <Tag color='processing'>รอขนส่งเข้ารับพัสดุ</Tag>;
    } else if (order.shipping_status === 'shipping') {
      return <Tag color='success'>ขนส่งเข้ารับพัสดุแล้ว</Tag>;
    } else if (order.shipping_status === 'package_detail') {
      return <Tag color='processing'>อัพเดทข้อมูลพัสดุ</Tag>;
    } else if (order.shipping_status === 'problem') {
      return <Tag color='error'>พัสดุมีปัญหา</Tag>;
    } else if (order.shipping_status === 'complete') {
      return <Tag color='success'>จัดส่งสำเร็จ</Tag>;
    } else if (order.shipping_status === 'return') {
      return <Tag color='error'>พัสดุถูกตีกลับต้นทาง</Tag>;
    } else {
      return <Tag color='error'>ไม่ทราบสถานะขนส่ง</Tag>;
    }
  } else if (order.order_status === 'PC_RCV') {
    return <Tag color='success'>ผู้ซื้อรับสินค้าแล้ว</Tag>;
  } else if (order.order_status === 'PC_RCV_TransBack') {
    return <Tag color='success'>ผู้ขายรับพัสดุตีกลับแล้ว</Tag>;
  } else if (order.order_status === 'PC_RTN_Refunded') {
    return <Tag color='warning'>โอนส่วนต่างคืนสินค้าแล้ว</Tag>;
  } else if (order.order_status === 'PC_RTN_Prepare') {
    return <Tag color='warning'>ผู้ซื้อเตรียมคืนสินค้า</Tag>;
  } else if (order.order_status === 'PC_RTN_Req') {
    return <Tag color='warning'>ผู้ซื้อขอคืนสินค้า</Tag>;
  } else if (order.order_status === 'PC_RTN_AC') {
    return <Tag color='warning'>ผู้ขายตอบรับการคืนสินค้า</Tag>;
  } else if (order.order_status === 'PC_RTN_Book') {
    return <Tag color='processing'>ผู้ซื้อเตรียมพัสดุส่งคืน</Tag>;
  } else if (order.order_status === 'PC_RTN_BookConfirm') {
    if (order.return_status === 'pending') {
      return <Tag color='processing'>จองระบบขนส่งแล้ว</Tag>;
    } else if (order.return_status === 'booking') {
      return <Tag color='processing'>รอขนส่งเข้ารับพัสดุ</Tag>;
    } else if (order.return_status === 'shipping') {
      return <Tag color='success'>ขนส่งเข้ารับพัสดุแล้ว</Tag>;
    } else if (order.return_status === 'package_detail') {
      return <Tag color='processing'>อัพเดทข้อมูลพัสดุ</Tag>;
    } else if (order.return_status === 'problem') {
      return <Tag color='error'>พัสดุมีปัญหา</Tag>;
    } else if (order.return_status === 'complete') {
      return <Tag color='success'>จัดส่งสำเร็จ</Tag>;
    } else if (order.return_status === 'return') {
      return <Tag color='error'>พัสดุถูกตีกลับต้นทาง</Tag>;
    } else {
      return <Tag color='error'>ไม่ทราบสถานะขนส่งการคืน</Tag>;
    }
  } else if (order.order_status === 'PC_RTN_RCV') {
    return <Tag color='warning'>ผู้ขายรับสินค้าคืนแล้ว</Tag>;
  } else {
    return <Tag color='error'>ไม่ทราบสถานะ</Tag>;
  }
}
